module.exports = __webpack_public_path__ + "static/monei_pay_form_es-87f01216fc36823ac1732368edd43b0f.png";